module.exports = __webpack_public_path__ + "static/media/Coverphoto-Profile.d3ad366a.jpg";